"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _dateInputModule = _interopRequireDefault(require("./dateInput.module.css"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _calendarIcon = _interopRequireDefault(require("../icons/calendarIcon"));

require("react-datepicker/dist/react-datepicker.css");

var _reactDatepicker2 = _interopRequireDefault(require("react-datepicker"));

var _loader = _interopRequireDefault(require("../loader/loader"));

var _clockIcon = _interopRequireDefault(require("../icons/clockIcon"));

var _constants = require("../../../utils/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DateLoader = function DateLoader(props) {
  var isLoading = props.isLoading,
      id = props.id;
  return _react.default.createElement(_react.default.Fragment, null, isLoading && _react.default.createElement(_loader.default, {
    id: id ? "".concat(id, "_loader") : null,
    variant: "dots"
  }));
};

var DateInput = function DateInput(props) {
  var id = props.id,
      dateInputProps = props.dateInputProps,
      isLoading = props.isLoading,
      icon = props.icon,
      hideDisabledTimeOptions = props.hideDisabledTimeOptions;
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, _dateInputModule.default["buttonPickerWrapper"], hideDisabledTimeOptions ? _dateInputModule.default["hiddenDisabledOptions"] : "")
  }, _react.default.createElement(_reactDatepicker2.default, _extends({
    className: (0, _classnames.default)(_themeModule.default.arag, _dateInputModule.default["form-control-custom"])
  }, dateInputProps, {
    id: id ? "".concat(id, "_date_input") : null
  })), _react.default.createElement(DateLoader, {
    isLoading: isLoading,
    id: id
  }), _react.default.createElement("button", {
    id: id ? "".concat(id, "_button") : null,
    className: (0, _classnames.default)(_dateInputModule.default["btn"], _dateInputModule.default["form-control"], _dateInputModule.default["buttonPicker"]),
    tabIndex: -1
  }, icon === _constants.DATE_INPUT_ICONS.clock ? _react.default.createElement(_clockIcon.default, {
    id: id ? "".concat(id, "_icon") : null,
    className: _dateInputModule.default["icon-calendar"]
  }) : _react.default.createElement(_calendarIcon.default, {
    id: id ? "".concat(id, "_icon") : null,
    className: _dateInputModule.default["icon-calendar"]
  })));
};

DateInput.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** dateInputProps is an object based on the props of the component: (https://github.com/Hacker0x01/react-datepicker/blob/master/docs/datepicker.md)*/
  dateInputProps: _propTypes.default.object.isRequired,

  /** Boolean indicating if the component is loading  */
  isLoading: _propTypes.default.bool,

  /** Boolean indicating if the disabled time options should be hidden */
  hideDisabledTimeOptions: _propTypes.default.bool,

  /**icon is a string that specifies the icon to be displayed in the button */
  icon: _propTypes.default.string
};
var _default = DateInput;
exports.default = _default;